import ApiResponse from "../models/apiResponse";
import apiClient from "./client";
import RoutineProperties from "../models/routineProperties";
import QueryContext from "../models/queryContext";
import Util from "./util";

export default {
  async all(params: QueryContext): Promise<ApiResponse> {
    const url = "/api/v1/routines";

    return await apiClient.get(url, {
      headers: Util.authHeaders(),
      params: params,
    });
  },
  async create(properties: RoutineProperties): Promise<ApiResponse> {
    const url = "/api/v1/routines";
    return await apiClient.post(url, properties, {
      headers: Util.authHeaders(),
    });
  },
  async delete(routineId: number): Promise<ApiResponse> {
    const url = `/api/v1/routines/${routineId}`;
    return await apiClient.delete(url, { headers: Util.authHeaders() });
  },
  async get(routineId: number): Promise<ApiResponse> {
    const url = `/api/v1/routines/${routineId}`;
    return await apiClient.get(url, { headers: Util.authHeaders() });
  },
  async update(
    routineId: number,
    properties: RoutineProperties,
  ): Promise<ApiResponse> {
    const url = `/api/v1/routines/${routineId}`;
    return await apiClient.put(url, properties, {
      headers: Util.authHeaders(),
    });
  },
};
